"use strict";
// 聊天工具函数与业务逻辑模块
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.printTerminalTable = exports.padEndDisplay = exports.getDisplayWidth = exports.getConfigPath = exports.getCliRoot = void 0;
exports.loadSavedConfig = loadSavedConfig;
exports.saveConfig = saveConfig;
exports.ensureAgentServerRunning = ensureAgentServerRunning;
exports.handleConfigReuse = handleConfigReuse;
exports.setupConnection = setupConnection;
exports.fetchAndSelectModels = fetchAndSelectModels;
exports.saveAndPrintConfig = saveAndPrintConfig;
exports.runChatLoop = runChatLoop;
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const cli_core_1 = require("@/cli-core");
const cli_api_1 = require("@/cli-api");
const util_1 = require("../start-server/util");
/**
 * 获取 code-agent 的根目录，优先从环境变量获取，兜底使用当前工作目录
 * @returns 根目录绝对路径
 */
const getCliRoot = () => process.env.cliRoootPath || process.cwd();
exports.getCliRoot = getCliRoot;
/**
 * 获取命令配置文件路径
 * @returns 配置文件绝对路径
 */
const getConfigPath = () => path.join((0, exports.getCliRoot)(), 'src', 'config', 'commands.json');
exports.getConfigPath = getConfigPath;
/**
 * 计算字符串在终端中的实际显示宽度（中文字符算 2 个宽度，英文算 1 个）
 * @param str 目标字符串
 * @returns 终端显示宽度
 */
const getDisplayWidth = (str) => {
    let width = 0;
    for (const char of str) {
        if (char.charCodeAt(0) > 127) {
            width += 2;
        }
        else {
            width += 1;
        }
    }
    return width;
};
exports.getDisplayWidth = getDisplayWidth;
/**
 * 根据实际显示宽度进行右侧填充对齐
 * @param str 原始字符串
 * @param targetWidth 目标显示宽度
 * @returns 填充对齐后的字符串
 */
const padEndDisplay = (str, targetWidth) => {
    const currentWidth = (0, exports.getDisplayWidth)(str);
    const diff = targetWidth - currentWidth;
    return str + ' '.repeat(Math.max(0, diff));
};
exports.padEndDisplay = padEndDisplay;
/**
 * 通用终端动态表格打印函数
 * @param title 表格标题
 * @param headers 表头列表
 * @param rows 数据行列表
 */
const printTerminalTable = (title, headers, rows) => {
    const numCols = headers.length;
    const colWidths = headers.map((header, colIndex) => {
        const maxLen = Math.max((0, exports.getDisplayWidth)(header), ...rows.map(row => (0, exports.getDisplayWidth)(row[colIndex] || '')));
        return maxLen + 2;
    });
    let totalInnerWidth = colWidths.reduce((sum, w) => sum + w, 0) + (numCols - 1);
    const paddedTitleText = ` ${title} `;
    const paddedTitleW = (0, exports.getDisplayWidth)(paddedTitleText);
    if (paddedTitleW > totalInnerWidth) {
        const diff = paddedTitleW - totalInnerWidth;
        colWidths[colWidths.length - 1] += diff;
        totalInnerWidth = paddedTitleW;
    }
    const topBorder = `┌${'─'.repeat(totalInnerWidth)}┐`;
    const titleSeparator = `├${colWidths.map(w => '─'.repeat(w)).join('┬')}┤`;
    const midBorder = `├${colWidths.map(w => '─'.repeat(w)).join('┼')}┤`;
    const btmBorder = `└${colWidths.map(w => '─'.repeat(w)).join('┴')}┘`;
    const leftPad = Math.floor((totalInnerWidth - paddedTitleW) / 2);
    const rightPad = totalInnerWidth - paddedTitleW - leftPad;
    const finalTitleLine = ' '.repeat(Math.max(0, leftPad)) + paddedTitleText + ' '.repeat(Math.max(0, rightPad));
    cli_core_1.CLI.log.info('');
    cli_core_1.CLI.log.info(topBorder);
    cli_core_1.CLI.log.info(`│${finalTitleLine}│`);
    cli_core_1.CLI.log.info(titleSeparator);
    const headerStr = headers.map((h, i) => (0, exports.padEndDisplay)(h, colWidths[i])).join('│');
    cli_core_1.CLI.log.info(`│${headerStr}│`);
    cli_core_1.CLI.log.info(midBorder);
    rows.forEach(row => {
        const rowStr = row.map((cell, i) => (0, exports.padEndDisplay)(cell || '', colWidths[i])).join('│');
        cli_core_1.CLI.log.info(`│${rowStr}│`);
    });
    cli_core_1.CLI.log.info(btmBorder + '\n');
};
exports.printTerminalTable = printTerminalTable;
/**
 * 加载本地保存的 AI 配置
 * @returns 返回解析后的 AISetting 对象，若不存在或损坏则返回 null
 */
function loadSavedConfig() {
    try {
        const configPath = (0, exports.getConfigPath)();
        if (fs.existsSync(configPath)) {
            const raw = fs.readFileSync(configPath, 'utf8');
            const data = JSON.parse(raw);
            const setting = data.aiSetting;
            if (setting && setting.baseUrl && setting.model && setting.options) {
                return setting;
            }
        }
    }
    catch (e) { }
    return null;
}
/**
 * 保存 AI 配置到 commands.json 文件中
 * @param settings AI 设置对象
 */
function saveConfig(settings) {
    try {
        const configPath = (0, exports.getConfigPath)();
        const dir = path.dirname(configPath);
        if (!fs.existsSync(dir)) {
            fs.mkdirSync(dir, { recursive: true });
        }
        let config = {};
        if (fs.existsSync(configPath)) {
            config = JSON.parse(fs.readFileSync(configPath, 'utf8'));
            config.aiSetting = settings;
            fs.writeFileSync(configPath, JSON.stringify(config, null, 2), 'utf8');
        }
    }
    catch (e) { }
}
/**
 * 检查本地 coda-agent-server 是否通过 PM2 正常运行，未启动则自动调用 coda start server 启动
 * @param serverName 服务名称
 */
async function ensureAgentServerRunning(serverName) {
    cli_core_1.CLI.loading.start(`正在检查 PM2 及 ${serverName} 运行状态...`);
    const isPm2Installed = await (0, util_1.checkPM2Installed)();
    if (!isPm2Installed) {
        cli_core_1.CLI.loading.info('未检测到全局 PM2 守护工具，正在通过 coda 自动启动服务...');
        await cli_core_1.ChildProcess.runCmdLive('coda start server', process.cwd());
        return;
    }
    const { exists, online } = await (0, util_1.checkServerStatus)(serverName);
    if (!exists || !online) {
        cli_core_1.CLI.loading.start(`${serverName} 未在后台正常运行，正在自动启动服务...`);
        await cli_core_1.ChildProcess.runCmdLive('coda start server', process.cwd());
        cli_core_1.CLI.loading.succeed(`${serverName} 启动成功`);
    }
    else {
        cli_core_1.CLI.loading.succeed(`${serverName} 已经在后台正常运行中。`);
    }
}
/**
 * 跨平台打开浏览器访问指定链接
 * @param url 目标网址
 */
async function openBrowser(url) {
    const platform = process.platform;
    let cmd = '';
    if (platform === 'win32') {
        cmd = `start ${url}`;
    }
    else if (platform === 'darwin') {
        cmd = `open ${url}`;
    }
    else {
        cmd = `xdg-open ${url}`;
    }
    await cli_core_1.ChildProcess.runCmdAsync(cmd);
}
/**
 * 验证大模型服务是否连通
 * @param protocol 协议类型
 * @param baseUrl 服务地址
 * @param apiKey 密钥
 * @returns 是否连通成功
 */
async function verifyAiServiceConnection(protocol, baseUrl, apiKey) {
    try {
        let healthUrl = '';
        const headers = {};
        const cleanBaseUrl = baseUrl.replace(/\/$/, '');
        if (protocol === 'openai') {
            healthUrl = `${cleanBaseUrl}/models`;
            if (apiKey)
                headers['Authorization'] = `Bearer ${apiKey}`;
        }
        else {
            healthUrl = `${cleanBaseUrl}/api/tags`;
        }
        const res = await fetch(healthUrl, { method: 'GET', headers });
        return res.status < 500;
    }
    catch {
        return false;
    }
}
/**
 * 处理已有配置的复用逻辑
 * @param savedConfig 本地已保存的 AISetting 配置
 * @returns 返回包含复用状态及解析后配置的对象
 */
async function handleConfigReuse(savedConfig) {
    if (!savedConfig || !savedConfig.baseUrl || !savedConfig.model) {
        return { reused: false };
    }
    const ctxNum = savedConfig.options?.contextSize || 32768;
    const ctxLabel = `${Math.round(ctxNum / 1024)}k`;
    const protocolLabel = savedConfig.protocol === 'openai' ? 'OpenAI 协议' : 'Ollama 协议';
    if (savedConfig.options?.architectureModel) {
        (0, exports.printTerminalTable)(`📋 AI 当前配置 [${protocolLabel}] (多模型协作)`, ['AI服务网关', '设计模型', '编码模型', '上下文大小'], [[savedConfig.baseUrl, savedConfig.options.architectureModel, savedConfig.model, ctxLabel]]);
    }
    else {
        (0, exports.printTerminalTable)(`📋 AI 当前配置 [${protocolLabel}]`, ['AI服务网关', '模型', '上下文大小'], [[savedConfig.baseUrl, savedConfig.model, ctxLabel]]);
    }
    const reuseAns = await cli_core_1.CLI.addQuestions([
        {
            type: 'confirm',
            name: 'reuse',
            message: `检测到已有配置(见上面表格)，是否继续使用？`,
            default: true,
        },
    ]);
    if (reuseAns.reuse) {
        const isConnected = await verifyAiServiceConnection(savedConfig.protocol || 'ollama', savedConfig.baseUrl, savedConfig.apiKey || '');
        if (!isConnected) {
            cli_core_1.CLI.loading.fail(`无法连接到大模型服务 (${savedConfig.baseUrl})，请确保大模型服务已被启动。`);
            const docAns = await cli_core_1.CLI.addQuestions([
                {
                    type: 'confirm',
                    name: 'showDoc',
                    message: '是否显示大模型服务的下载步骤安装文档？',
                    default: true,
                },
            ]);
            if (docAns.showDoc) {
                await openBrowser('https://www.npmjs.com/package/coda-cli');
                cli_core_1.CLI.loading.info('🌐 已为您在浏览器中打开安装文档页面。');
            }
            throw new Error('大模型服务未启动，配置中断。');
        }
        let enableMultiModel = false;
        let architectureModel = savedConfig.options?.architectureModel || '';
        let implementationModel = savedConfig.model;
        let options = { ...savedConfig.options };
        if (savedConfig.options?.architectureModel) {
            enableMultiModel = true;
        }
        cli_core_1.CLI.loading.info('已直接复用现有 AI 配置。');
        return {
            reused: true,
            protocol: savedConfig.protocol || 'ollama',
            baseUrl: savedConfig.baseUrl,
            apiKey: savedConfig.apiKey || '',
            model: savedConfig.model,
            agentServerUrl: savedConfig.agentServerUrl || 'http://127.0.0.1:10086',
            options,
            enableMultiModel,
            architectureModel,
            implementationModel,
        };
    }
    return { reused: false };
}
/**
 * 交互式引导：设置协议与连接网关（含服务连通性校验与拦截）
 * @param savedConfig 本地保存的配置（用于提供默认值）
 * @returns 包含用户选择的协议、网关地址与 API Key 的对象
 */
async function setupConnection(savedConfig) {
    const protocolAns = await cli_core_1.CLI.addQuestions([
        {
            type: 'select',
            name: 'protocol',
            message: '请选择大模型部署服务协议:',
            choices: [
                { name: 'Ollama 协议', value: 'ollama' },
                { name: 'OpenAI 兼容协议', value: 'openai' },
            ],
            default: savedConfig?.protocol || 'ollama',
        },
    ]);
    const protocol = protocolAns.protocol;
    const defaultBaseUrl = protocol === 'openai' ? 'https://api.openai.com/v1' : 'http://127.0.0.1:11434';
    const connectionAns = await cli_core_1.CLI.addQuestions([
        {
            type: 'input',
            name: 'baseUrl',
            message: '请输入大模型部署服务地址 (Base URL):',
            default: savedConfig?.baseUrl || defaultBaseUrl,
            validate: async (value) => {
                try {
                    new URL(value);
                }
                catch {
                    return '格式错误：请输入合法的网址（例如：http://127.0.0.1:11434）';
                }
                return true;
            },
        },
        {
            type: 'input',
            name: 'apiKey',
            message: '请输入密钥 (API Key，若服务器无需鉴权可直接回车):',
            default: savedConfig?.apiKey || '',
        },
    ]);
    const baseUrl = connectionAns.baseUrl;
    const apiKey = connectionAns.apiKey || '';
    cli_core_1.CLI.loading.info(`正在检测大模型服务连通性 (${baseUrl})...`);
    const isConnected = await verifyAiServiceConnection(protocol, baseUrl, apiKey);
    if (!isConnected) {
        cli_core_1.CLI.loading.fail(`无法连接到大模型服务，请确保大模型服务已被启动。`);
        const docAns = await cli_core_1.CLI.addQuestions([
            {
                type: 'confirm',
                name: 'showDoc',
                message: '是否显示大模型服务的下载步骤安装文档？',
                default: true,
            },
        ]);
        if (docAns.showDoc) {
            await openBrowser('https://www.npmjs.com/package/coda-cli');
            cli_core_1.CLI.loading.info('🌐 已为您在浏览器中打开安装文档页面。');
        }
        throw new Error('大模型服务未启动或无法连接，配置流程已中断。');
    }
    cli_core_1.CLI.loading.succeed('大模型服务连接成功！');
    return {
        protocol,
        baseUrl,
        apiKey,
    };
}
/**
 * 拉取远程模型列表并交互式选择模型协作模式
 * @param protocol 协议类型 ('ollama' | 'openai')
 * @param baseUrl 大模型服务网关地址
 * @param apiKey 鉴权密钥
 * @returns 返回模型列表及选中的模型、协作模式等配置
 */
async function fetchAndSelectModels(protocol, baseUrl, apiKey) {
    let modelList = [];
    try {
        let tagsUrl = '';
        const headers = {};
        if (protocol === 'openai') {
            tagsUrl = `${baseUrl.replace(/\/$/, '')}/models`;
            if (apiKey)
                headers['Authorization'] = `Bearer ${apiKey}`;
        }
        else {
            tagsUrl = `${baseUrl.replace(/\/$/, '')}/api/tags`;
        }
        const tagsRes = await cli_api_1.request.ajax(tagsUrl, 'get');
        if (tagsRes && tagsRes.data && tagsRes.data.models) {
            modelList = tagsRes.data.models.map((m) => m.name || m.id);
        }
        else if (Array.isArray(tagsRes)) {
            modelList = tagsRes.map((m) => m.name || m.id || m);
        }
        const modelRows = modelList.map((m, idx) => [`[${idx + 1}]`, m]);
        (0, exports.printTerminalTable)('可用 AI 模型列表', ['序号', '模型名称'], modelRows);
    }
    catch (e) {
        cli_core_1.CLI.loading.fail(`获取模型列表失败，将使用默认兜底模型: ${e.message}`);
    }
    if (!modelList || modelList.length === 0) {
        modelList = ['qwen3-coder:30b', 'deepseek-r1:32b'];
    }
    const modelChoices = modelList.map((m) => ({
        name: m,
        value: m,
    }));
    const modeAnswers = await cli_core_1.CLI.addQuestions([
        {
            type: 'confirm',
            name: 'enableMultiModel',
            message: '是否启用多模型协作 (架构规划 + 代码实现)?',
            default: false,
        },
    ]);
    const enableMultiModel = modeAnswers.enableMultiModel;
    let architectureModel = modelList[1] || modelList[0];
    let implementationModel = modelList[0];
    let model = modelList[0];
    let taskMode = 'coding';
    if (enableMultiModel) {
        const archAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'architectureModel',
                message: '请选择 1. 架构设计模型(先按回车键，再使用上下箭头选择):',
                choices: modelChoices,
                default: architectureModel,
            },
        ]);
        architectureModel = archAnswers.architectureModel;
        const implAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'implementationModel',
                message: '请选择 2. 代码实现模型:',
                choices: modelChoices,
                default: implementationModel,
            },
        ]);
        implementationModel = implAnswers.implementationModel;
        model = implAnswers.implementationModel;
    }
    else {
        const singleAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'model',
                message: '请选择要调用的 AI 模型:',
                choices: modelChoices,
                default: implementationModel,
            },
            {
                type: 'select',
                name: 'taskMode',
                message: '请选择工作模式:',
                choices: [
                    { name: '💻 代码实现 (Coding)', value: 'coding' },
                    { name: '🔍 代码审查 (Code Review)', value: 'review' },
                ],
                default: 'coding',
            },
        ]);
        model = singleAnswers.model;
        taskMode = singleAnswers.taskMode;
    }
    return {
        modelList,
        enableMultiModel,
        architectureModel,
        implementationModel,
        model,
        taskMode,
    };
}
/**
 * 交互式选择模型上下文大小，持久化保存配置并打印终端配置表格
 * @param currentSettings 当前完整的 AI 设置对象
 * @returns 返回最终选择的上下文大小数值
 */
async function saveAndPrintConfig(currentSettings) {
    const contextAnswers = await cli_core_1.CLI.addQuestions([
        {
            type: 'select',
            name: 'contextSize',
            message: '请选择模型上下文大小 (Context Size):',
            choices: [
                { name: '8K (8192)', value: 8192 },
                { name: '16K (16384)', value: 16384 },
                { name: '32K (32768) [推荐]', value: 32768 },
                { name: '64K (65536)', value: 65536 },
                { name: '128K (131072)', value: 131072 },
            ],
            default: 32768,
        },
    ]);
    const contextSize = Number(contextAnswers.contextSize);
    currentSettings.options.contextSize = contextSize;
    currentSettings.options.architectureModel = currentSettings.options.architectureModel
        ? currentSettings.options.architectureModel
        : undefined;
    saveConfig(currentSettings);
    const savedCtxLabel = `${Math.round(contextSize / 1024)}k`;
    const protocolLabel = currentSettings.protocol === 'openai' ? 'OpenAI 协议' : 'Ollama 协议';
    if (currentSettings.options.architectureModel) {
        (0, exports.printTerminalTable)(`📋 AI配置已保存 [${protocolLabel}] (多模型协作)`, ['AI服务网关', '设计模型', '编码模型', '上下文大小'], [
            [
                currentSettings.baseUrl,
                currentSettings.options.architectureModel,
                currentSettings.model,
                savedCtxLabel,
            ],
        ]);
    }
    else {
        (0, exports.printTerminalTable)(`📋 AI配置已保存 [${protocolLabel}]`, ['AI服务网关', '模型', '上下文大小'], [[currentSettings.baseUrl, currentSettings.model, savedCtxLabel]]);
    }
    cli_core_1.CLI.loading.succeed('AI 模型配置已成功写入项目配置文件。');
    return contextSize;
}
/**
 * 核心流式对话循环：向 coda-agent-server 发起 POST 请求并以流式方式实时打印大模型响应
 * @param settings AI 设置对象
 * @param taskMode 工作模式 ('coding' | 'review')
 * @returns 返回对话结束时的成功状态布尔值
 */
async function runChatLoop(settings, taskMode) {
    cli_core_1.CLI.loading.info('正在连接至 Coda Agent Server 运行环境...');
    const protocolLabel = settings.protocol === 'openai' ? 'OpenAI 协议' : 'Ollama 协议';
    if (settings.options.architectureModel) {
        cli_core_1.CLI.loading.info(`[多模型协作模式 - ${protocolLabel}] 架构: ${settings.options.architectureModel} | 实现: ${settings.model} | 上下文: ${settings.options.contextSize}\n`);
    }
    else {
        cli_core_1.CLI.loading.info(`[${taskMode === 'review' ? '代码审查模式' : '编码实现模式'} - ${protocolLabel}] 模型: ${settings.model} | 上下文: ${settings.options.contextSize}\n`);
    }
    let isRunning = true;
    let success = false;
    while (isRunning) {
        const inputAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'input',
                name: 'userPrompt',
                message: '💬 请输入任务需求 (输入 "退出" 结束):',
                default: '',
            },
        ]);
        const rawInput = (inputAnswers.userPrompt || '').trim();
        if (rawInput === '退出') {
            cli_core_1.CLI.loading.info('正在退出 AI 编程助手，再见！');
            isRunning = false;
            success = true;
            break;
        }
        if (!rawInput) {
            continue;
        }
        cli_core_1.CLI.loading.info('AI 思考与工具调用中...');
        let firstChunkReceived = false;
        let hasServerError = false;
        try {
            const targetUrl = `${settings.agentServerUrl.replace(/\/$/, '')}/api/chat/completions`;
            const requestBody = {
                settings: {
                    protocol: settings.protocol,
                    baseUrl: settings.baseUrl,
                    apiKey: settings.apiKey,
                    model: settings.model,
                    agentServerUrl: settings.agentServerUrl,
                    options: {
                        contextSize: settings.options.contextSize,
                        architectureModel: settings.options.architectureModel,
                    },
                },
                prompt: rawInput,
            };
            const res = await fetch(targetUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            if (!res.ok || !res.body) {
                throw new Error(`连接 coda-server 失败: 状态码 ${res.status}`);
            }
            const reader = res.body.getReader();
            const decoder = new TextDecoder('utf-8');
            while (true) {
                const { done, value } = await reader.read();
                if (done)
                    break;
                const chunk = decoder.decode(value, { stream: true });
                if (chunk) {
                    if (!firstChunkReceived) {
                        firstChunkReceived = true;
                        cli_core_1.CLI.loading.info('AI 响应开始流式传输...');
                    }
                    process.stdout.write(chunk);
                    if (chunk.includes('[Server Error]') || chunk.includes('fetch failed')) {
                        hasServerError = true;
                    }
                }
            }
            if (!firstChunkReceived) {
                cli_core_1.CLI.loading.succeed('AI 响应完成');
            }
            console.log('\n');
            if (hasServerError) {
                cli_core_1.CLI.loading.fail('检测到大模型服务连接失败，请确保大模型服务已被正确启动。');
                const docAns = await cli_core_1.CLI.addQuestions([
                    {
                        type: 'confirm',
                        name: 'showDoc',
                        message: '是否显示大模型服务的下载步骤安装文档？',
                        default: true,
                    },
                ]);
                if (docAns.showDoc) {
                    await openBrowser('https://www.npmjs.com/package/coda-cli');
                    cli_core_1.CLI.loading.info('🌐 已为您在浏览器中打开安装文档页面。');
                }
            }
        }
        catch (err) {
            cli_core_1.CLI.loading.fail(`AI 任务执行出错: ${err.message}`);
        }
    }
    return success;
}
